module.exports = __webpack_public_path__ + "static/media/sign6.d159304e.png";